var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2071 2.18172C16.5976 1.79119 16.5976 1.15803 16.2071 0.767502C15.8166 0.376977 15.1834 0.376977 14.7929 0.767502L16.2071 2.18172ZM8.5 8.47461L7.79289 9.18172C8.18342 9.57224 8.81658 9.57224 9.20711 9.18172L8.5 8.47461ZM2.20711 0.767503C1.81658 0.376978 1.18342 0.376978 0.792893 0.767503C0.402369 1.15803 0.402369 1.79119 0.792893 2.18172L2.20711 0.767503ZM14.7929 0.767502L7.79289 7.7675L9.20711 9.18172L16.2071 2.18172L14.7929 0.767502ZM9.20711 7.7675L2.20711 0.767503L0.792893 2.18172L7.79289 9.18172L9.20711 7.7675Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.145ff8d7e2579d7829583fe3c812e82a.svg";
export { ForwardRef as ReactComponent };